import React, {useEffect} from 'react';
import {observer} from "mobx-react-lite";
import {reaction} from "mobx";
import {BottomNavigationBarComponent} from "../../bottom-navigation-bar/bottom-navigation-bar.component";
import {VideoSlidesArenaBox} from "./boxes/video-slides-arena.box";
//import {VideoSlidesContentArena} from "./video-slides-arena-content/video-slides-arena-content.component";
import {VideoSlidesHeaderArena} from "./video-slides-arena-header/video-slides-arena-header.component";
import {useServices} from '../../../react-hooks/use-services.hook';
import {VideoSlidesArenaSwiperComponent} from "./video-slides-arena-swiper/video-slides-arena-swiper.component";
import {DialogButtonClickHandleResultEnum} from "../../../services/dialog/dialog.service.interface";

export const VideoSlidesArena: React.FC = observer(() => {
    const services = useServices();

    useEffect(() => {
        const showVideoSlidesNotAvailablePopup = () => {
            services.dialog.showSimpleTextModal({
                disableFullscreenMobile: true,
                title: services.translation.translate('EXPLORER_NOT_AVAILABLE_TITLE'),
                text: services.translation.translate('EXPLORER_NOT_AVAILABLE_TEXT'),
                iconSvg: services.theme.currentTheme.icons.infoIcon,
                buttons: [
                    {
                        text: services.translation.translate('CLOSE'),
                        buttonPreset: 'primary',
                        onClick: async () => DialogButtonClickHandleResultEnum.CloseDialogAndContinue
                    }]
            });
        };

        const reactionDispose = reaction(() => services.videoSlides.shouldBeDisplayed,
            (shouldBeDisplayed) => {
                if (!shouldBeDisplayed) {
                    services.location.goHome().then(() => showVideoSlidesNotAvailablePopup())
                }
            }, {
            fireImmediately: true
        })

        return () => {
            reactionDispose();
        }
    }, [services.location, services.videoSlides.shouldBeDisplayed, services.dialog, services.theme, services.translation]);

    return (
        <VideoSlidesArenaBox>
            <VideoSlidesHeaderArena />
            <VideoSlidesArenaSwiperComponent/>
            <BottomNavigationBarComponent isInVideoSlidesArena={true} />
        </VideoSlidesArenaBox>
    );
})